export const getParameterByName = (name: string): string => {
  return new URLSearchParams(window.location.search).get(name);
};

